import NavLink from "../NavLink/NavLink";
import MegaMenuContainer from "../MegaMenu/MegaMenuContainer/MegaMenuContainer";
import { Button } from "@mantine/core";
import MegaMenuSection from "../MegaMenu/MegaMenuSection/MegaMenuSection";
import { useHeaderContext } from "../../../context/Header/HeaderContext";
import { useAppContext } from "../../../context/AppState/AppContext";
import { Link } from "react-router-dom";

export default function HeaderNavList() {
  const { isMobile, jsonFeatures, jsonTexts, jsonColors } = useAppContext();
  const { toggleBurger, onMouseEnterMenu, onMouseLeaveMenu, onClickMegaMenu } = useHeaderContext();
  const subscriptionLevel  = jsonFeatures.subscriptionLevel;
  const isMegaMenu = jsonFeatures?.pages?.headers?.withMegaMenu;
  const { aboutUsPage, contact } = jsonFeatures.appRoutes;

  const { header } = jsonTexts;
  const { inicio, institucional, ofertaAcademica, contacto, campus } = header;

  return (
    <ul
      className={`navbar-navlinks-container ${
        toggleBurger ? "navbar-toggle-active" : "navbar-toggle-inactive"
      }`}
    >
      <NavLink text={inicio.text} to={inicio.redirectTo} />

      {aboutUsPage[subscriptionLevel] && (
        <NavLink text={institucional.text} to={institucional.redirectTo} />
      )}

      {isMobile || !isMegaMenu ? (
        <NavLink text={ofertaAcademica.text} to={ofertaAcademica.redirectTo} />
      ) : (
        <NavLink
          text={ofertaAcademica.text}
          onMouseEnter={onMouseEnterMenu}
          onMouseLeave={onMouseLeaveMenu}
          onClick={onClickMegaMenu}
          withMenu
        >
          <MegaMenuContainer>
            <MegaMenuSection />
          </MegaMenuContainer>
        </NavLink>
      )}

      {contact[subscriptionLevel] && <NavLink text={contacto.text} to={contacto.redirectTo} />}
      <Button
        component={Link}
        to={campus.redirectTo}
        fw="normal"
        color={"#AF926A"}
        radius="normal"
      >
        {campus.text}
      </Button>
    </ul>
  );
}
